import * as S from "../../Style/Page/General.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleGeneral.js";
import HatPageTopLine from "../../Component/GeneralTopLine.js";


import MainImg from "../../assets/GeneralBusiness/목장.png";
import TableImgKor from "../../assets/GeneralBusiness/목장사업.png?v=1";
import TableImgEng from "../../assets/GeneralBusiness/목장사업영어.png";
// const TableImgKor = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/normal-kor.821304b38e03dd3f1e12fe4c16a4c67a.svg`;
// const TableImgEng = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/normal-eng.a24b49d7d46ac0eee7098dd0ea906ff1.svg`;
const Item1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/10. 영안얀행.838f7e10dab9124ca628.png`;
const Item2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/11. 화곡2공장.3913321a3ca2272d8e38.png`;
const Introduce = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"일반사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/GeneralBusiness/introduce">
                <div className="kor">일반사업</div>
                <div className="eng">General Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"104px"}>
            <S.NavItem>
              <Link to="/GeneralBusiness/Introduce">
                <div className="kor">일반사업소개</div>
                <div className="eng">Miscellaneous Business</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/Introduce">
                  <div className="kor">일반사업소개</div>
                  <div className="eng">Miscellaneous Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"사업개요"} titleeng={"Company Profile"} />
            <div className="page-text">
              <div className="kor">
                영안모자는 1972년~1980년대 모자 생산을 지원하기 위한 각종 자재와 부품을 직접 생산하는 수직
계열화를 추진하는 과정에서 여러 가지 새로운 사업을 시작했습니다.
이후 새로운 성장동력을 확보하기 위한 목적으로 1980년대 하반기부터 본격적인 사업다각화를 추진
했습니다. 특히, 1990년대 후반에 설립한 부천자동차 매매단지 운영을 통해 얻은 노하우는 추후 자동차
판매사업 진출의  계기가 되었으며, 2000년대 초에 진행한 휴대폰 제조사업의 경험은 영안이 새로 진출한
상용차, 지게차의 전장품 개발에 도움을 주었고, 2015년에 인수한 단성골드빌딩은 귀금속 도·소매사업에
진출하는 계기가 되었습니다. 
앞으로도 영안은 새로운 사업의 기회를 계속 찾으며 다양한 사업에 도전을 해 나갈 예정입니다.
              </div>
              <div className="eng">
                YoungAn Hat started many new businesses in the 1972s and 1980s when it was pushing for 
vertical integration of production of various materials and components to support the 
production of hats.
Since then, it has been pushing for diversification of its businesses since the second half of the 
1980s with the aim of securing new growth engines.
In particular, the know-how gained through the operation of Bucheon Automobile Trade 
Complex, which was established in the late 1990s, served as an opportunity to enter the 
automobile sales business, while the experience of the mobile phone manufacturing business 
in the early 2000s helped to develop the electrical equipment of YoungAn's new commercial 
vehicles and forklift business, and Dansung Gold budiling, which was acquired in the 2015s, 
was an opportunity to enter the jewelry wholesale and retail business.
In the future, YoungAn will continue to look for opportunities for new businesses and challenge 
various businesses.
              </div>
            </div>

            <PageTitle
              titleko={"주요연혁"}
              titleeng={"Major History"}
            />
            <div className="page-text">
              <div className="kor">
                1987년 제주 호명목장 설립, 운영중
                <br />
                2009년 자일개발(주) 설립 / 종로 단성사 인수(2015년4월), 부동산
                임대업
                <br /> 2014년 영안상사(주) 법인 전환 / 부동산 임대, 용역 사업
                <br /> 2016년 호명골드(주) 신규 설립 / 금 도매업
                <br />
                2018년 호명관광(주) / 산장호텔 / 커피사업 시작
                <br /> 2020년 남영산업(주) 인수 / 제주 사이프러스CC 및 제주
                남영목장 운영<br />
                ＊ 사이프러스CC 2026년 현재 회원제(프라이빗) 42위 / 대중제(퍼블릭) 31위
              </div>
              <div className="eng">
                1987 : Established Homyoung farm in Jeju island and Operating
                <br />
                2009 : Established Zyle Development Co., Ltd. / Acquired
                Dansung-sa in Apr. 2015 / Realestate lease business
                <br />
                2014 : YoungAn Company Co., Ltd. Was converted into a
                corporation / Real estate lease business, Contract business
                <br />
                2016 : Established Homyoung Gold Co., Ltd. / Gold products
                wholesale
                <br />
                2018 : Homyoung Tourism / Sanjang Hotel / Started a coffee
                business
                <br />
                2020 : Acquired NamYeung Industrial Co., Ltd. / Operating
                Cypress Golf & resort and Namyeung farm in Jeju island<br />
                ＊ As of 2026, Cypress CC is ranked 42nd among private membership golf clubs
                      and 31st among public golf clubs
              </div>

              <S.ImgHolderFullsize>
                <img src={MainImg} className="holder-img" alt="" />
              </S.ImgHolderFullsize>

            </div>
            

            <PageTitle
              titleko={"일반사업 / 목장사업"}
              titleeng={"Miscellaneous Business / Farm Business"}
            />
            <div className="business-map business-map-kor kor">
  <img
    src={TableImgKor}
    alt="일반사업 및 목장사업"
    className="fullsize-map"
  />
  <a
    href="https://www.cypress.co.kr/"
    target="_blank"
    rel="noopener noreferrer"
    className="cypress-link"
    aria-label="사이프러스 컨트리클럽 홈페이지"
  />
</div>

<div className="business-map business-map-eng eng">
  <img
    src={TableImgEng}
    alt="Miscellaneous Business and Farm Business"
    className="fullsize-map"
  />
  <a
    href="https://www.cypress.co.kr/"
    target="_blank"
    rel="noopener noreferrer"
    className="cypress-link"
    aria-label="Cypress Country Club website"
  />
</div>
            {/* <S.ImgHolderFlex>
              <S.ImgHolderHarf>
                <img src={Item1} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">1972년 영안양행 개업</div>
                  <div className="eng">
                    Establishment of YoungAn International Co., Ltd.(former){" "}
                    <br /> in 1972
                  </div>
                </div>
              </S.ImgHolderHarf>
              <S.ImgHolderHarf>
                <img src={Item2} className="holder-img" alt="" />
                <div className="holder-name">
                  <div className="kor">1화곡 2공장(화곡중앙시장)</div>
                  <div className="eng">
                    2nd factory in Hwagok dong <br /> (Hwagok Jungang Market)
                  </div>
                </div>
              </S.ImgHolderHarf>
            </S.ImgHolderFlex> */}
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Introduce;
